import React,{useState} from "react";
import {ReactComponent as Addicon} from '../../../../../assets/icons/add.svg'; // Import your SVG icon
import "../../../../../css/CashflowModeller2/Buttons/AddIcon.css"; // Import your CSS file

/**
 * AddIcon component renders an interactive icon that toggles its clicked state on click.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Function} [props.onClick] - Optional callback function to be called when the icon is clicked.
 *
 * @example
 * <AddIcon onClick={() => console.log('Icon clicked!')} />
 */
const AddIcon = ({  onClick }) => {
  const [clicked, setClicked] = useState(false);

  // const handleClick = () => {
  //   navigate(link); // Navigate to the provided link
  // };

  return (
    <div
      className={`addicon ${clicked ? "clicked" : ""}`}
      onClick={() => {
        setClicked(!clicked); // Toggle the clicked state
        // handleClick();
        onClick && onClick();
      }}
    >
      <Addicon/>
    </div>
  );
};

export default AddIcon;
